import { getWFMValues } from '../../services/wfmValue';
import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '../../enums/QueryKey';
import { getDateRangeFromStartDateByAddingMonths } from '../../utils/dateUtils';
import { Dayjs } from '@utils/dayjs';

export const useCustomerBaseWFMs = (firstMonth: string | Date | Dayjs, KPINames: string[]) => {
    const { dateFrom, dateTo } = getDateRangeFromStartDateByAddingMonths(firstMonth, 6);

    // Convert Dayjs to ISO strings for the API - use UTC since WFM queries by month column
    const dateFromStr = dateFrom.toISOString();
    const dateToStr = dateTo.toISOString();

    const { data } = useQuery({
        queryKey: [QueryKey.WFMs, { dateFrom: dateFromStr, dateTo: dateToStr, kpiNames: KPINames }],
        queryFn: () => getWFMValues({ dateFrom: dateFromStr, dateTo: dateToStr, KPINames }),
        enabled: !!firstMonth && !!KPINames && KPINames.length > 0,
    });

    return [data];
};
